module.exports = __webpack_public_path__ + "img/start_academy_co.cc093b8d.png";